// @flow
import * as React from 'react';
import {HiOutlineChevronRight} from "react-icons/hi";
import {PiShoppingCartFill} from "react-icons/pi";

import {useNavigate} from "react-router-dom";


export default function Header(props) {
    let BG = props.transparent ?'bg-transparent' : 'bg-white';
    const navigate = useNavigate();

    return (
        <React.Fragment>
            <header className={"navbar px-2 navbar-dark bd-navbar actionbar rtl fixed-top max-w-lg text-center " + BG}>

                <div className="w-100 float-right text-big-1 ">
                    &nbsp;
                    {props.title?.substring(0, 25)}
                    {
                        props.title?.length > 25 ?
                            <span className='text-small-4'>
                                                    ...
                                                </span>
                            : ''
                    }

                </div>

                {
                    props.hasBack &&
                    <div className="position-absolute" onClick={() => {
                        props.backAddress ? window.location.replace(props.backAddress) : window.history.length > 1 ? window.history.back() : window.location.replace("/")
                    }}>
                        <HiOutlineChevronRight className='text-big-5 '/>
                    </div>
                }

            </header>
        </React.Fragment>
    );
};